export default __webpack_public_path__ + "static/media/interns.8b2d1e91.png";